import {create} from 'zustand';
import {ExamOrientationsInfoStore} from './types';

const INITIAL_EXAM_ORIENTATION_INFO = {
	code: '',
	examName: '',
	orientations: '',
};

const useExamOrientationsInfoStore = create<ExamOrientationsInfoStore>(set => ({
	examOrientationInfo: INITIAL_EXAM_ORIENTATION_INFO,
	setExamOrientationInfo: value => set({examOrientationInfo: value}),
	resetExamOrientationInfo: () => set({examOrientationInfo: INITIAL_EXAM_ORIENTATION_INFO}),
}));

export {useExamOrientationsInfoStore};
